import { createSlice } from '@reduxjs/toolkit'
import * as asyncActions from './reports.asynActions'
import {
	getFirstDateOfCurrentMonth,
	getUTCEndDate,
} from '../../widgets/CustomDateRangePicker/CustomDateRangePicker.utils'
import { isEmpty } from 'lodash'
import { FilterOperators } from './reports.constants'

const CURRENT_DATE = new Date()

const initialState = {
	totals: {},
	commission: {},
	unengagedUsers: [],
	churnedCustomers: [],
	productMix: {},
	filters: {
		startDate: getFirstDateOfCurrentMonth(),
		endDate: getUTCEndDate(CURRENT_DATE),
	},
	engagementChart: [],
	isDateSelected: false,
	totalsAdditional: [],
	commissionsAdditional: [],
	aditionalModal: null,
	selectedAdditionalDataModal: null,
	previousFilters: {},
	stores: [],
	reportCustomers: [],
	CloudReport: {},
	commissionsAdditionalType: null,
	cloudReportFilters: {
		page: 1,
		startIndex: 0,
		limit: 50,
		isPayingCustomer: [],
		documentLimit: { filterOperationType: FilterOperators.Equal },
		termPercentage: { filterOperationType: FilterOperators.Equal },
		currentTermDocuments: { filterOperationType: FilterOperators.Equal },
		lifeTimeDocuments: { filterOperationType: FilterOperators.Equal },
		zohoDealAmount: { filterOperationType: FilterOperators.Equal },
		zohoDealExpectedRevenue: { filterOperationType: FilterOperators.Equal },
		ChargeBeePlanAmount: { filterOperationType: FilterOperators.Equal },
	},
	CloudTiers: [],
}

const slice = createSlice({
	name: 'reports',
	initialState,
	reducers: {
		setCloudReportFilters(state, action) {
			state.cloudReportFilters = {
				...action.payload,
			}
		},
		setReportFilters(state, action) {
			state.filters = action.payload
		},
		setIsDateSelected(state, action) {
			state.isDateSelected = action.payload
		},
		setSelectedAdditionalDataModal(state, action) {
			state.selectedAdditionalDataModal = action.payload
		},
		setAdditionalModal(state, action) {
			state.aditionalModal = action.payload
		},
		resetTotalAdditional(state) {
			state.totalsAdditional = initialState.totalsAdditional
		},
		resetCommissionAdditional(state) {
			state.commissionsAdditional = initialState.commissionsAdditional
		},
		setCommissionsAdditionalType(state, action) {
			state.commissionsAdditionalType = action.payload
		},
		setPreviousFilters(state, action) {
			state.previousFilters = action.payload
		},
		resetUnengagedUsers(state) {
			state.unengagedUsers = initialState.unengagedUsers
		},
		resetChurnedCustomers(state) {
			state.churnedCustomers = initialState.churnedCustomers
		},
		resetEngagementChart(state) {
			state.engagementChart = initialState.engagementChart
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(asyncActions.fetchTotals.fulfilled, (state, action) => {
				state.totals = action.payload || initialState.totals
			})
			.addCase(asyncActions.fetchCommission.fulfilled, (state, action) => {
				state.commission = action.payload || initialState.commission
			})
			.addCase(asyncActions.fetchUnengagedUsers.fulfilled, (state, action) => {
				state.unengagedUsers = action.payload || initialState.unengagedUsers
			})
			.addCase(
				asyncActions.fetchChurnedCustomers.fulfilled,
				(state, action) => {
					state.churnedCustomers =
						action.payload || initialState.churnedCustomers
				}
			)
			.addCase(asyncActions.fetchProductMix.fulfilled, (state, action) => {
				state.productMix = action.payload || initialState.productMix
			})
			.addCase(
				asyncActions.fetchdocumentHistoriesEngagementChart.fulfilled,
				(state, action) => {
					state.engagementChart = isEmpty(state.engagementChart)
						? action.payload || initialState.engagementChart
						: action.payload &&
							state.engagementChart.map((each, index) =>
								Object.assign({}, each, action.payload[index])
							)
				}
			)
			.addCase(
				asyncActions.fetchUsersEngagementChart.fulfilled,
				(state, action) => {
					state.engagementChart = isEmpty(state.engagementChart)
						? action.payload || initialState.engagementChart
						: action.payload &&
							state.engagementChart.map((each, index) =>
								Object.assign({}, each, action.payload[index])
							)
				}
			)
			.addCase(
				asyncActions.fetchDocumentsEngagementChart.fulfilled,
				(state, action) => {
					state.engagementChart = isEmpty(state.engagementChart)
						? action.payload || initialState.engagementChart
						: action.payload &&
							state.engagementChart.map((each, index) =>
								Object.assign({}, each, action.payload[index])
							)
				}
			)
			.addCase(
				asyncActions.fetchTotalsAdditional.fulfilled,
				(state, action) => {
					state.totalsAdditional =
						action.payload || initialState.totalsAdditional
				}
			)
			.addCase(
				asyncActions.fetchCommissionsAdditional.fulfilled,
				(state, action) => {
					state.commissionsAdditional =
						action.payload || initialState.commissionsAdditional
				}
			)
			.addCase(asyncActions.fetchStores.fulfilled, (state, action) => {
				state.stores = action.payload || initialState.stores
			})
			.addCase(asyncActions.fetchReportCustomers.fulfilled, (state, action) => {
				state.reportCustomers = action.payload || initialState.reportCustomers
			})
			.addCase(asyncActions.fetchCloudReport.fulfilled, (state, action) => {
				state.CloudReport = action.payload || initialState.CloudReport
			})
			.addCase(asyncActions.getCloudTiers.fulfilled, (state, action) => {
				state.CloudTiers = action.payload || initialState.CloudTiers
			})
	},
})

export default slice

export const {
	name,
	actions: {
		setReportFilters,
		setCloudReportFilters,
		setSelectedAdditionalDataModal,
		setAdditionalModal,
		resetTotalAdditional,
		resetCommissionAdditional,
		setPreviousFilters,
		resetChurnedCustomers,
		resetUnengagedUsers,
		resetEngagementChart,
		setIsDateSelected,
		setCommissionsAdditionalType,
	},
	reducer,
} = slice
